/**
 * Diagnostics request lifecycle (Phase H).
 *
 * Use this for OCPP 2.0.1 chargers; legacy 1.6 chargers can also use the
 * remote-control `getDiagnostics` call but will not get a tracked
 * `request_id` back.
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  CreateDiagnosticsRequestBody,
  CreateDiagnosticsRequestResponse,
} from '../models';

export const requestDiagnostics = (chargerId: string, body: CreateDiagnosticsRequestBody) =>
  ocppRequest<CreateDiagnosticsRequestResponse>({
    method: 'POST',
    path: `diagnostics-request/${enc(chargerId)}`,
    body,
  });
